import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';

import { Store } from '@ngrx/store';

import { SessionManagerService } from '@core/services/session-manager.service';

import { ChangePasswordDialogComponent } from 'src/components/@shared/change-password-dialog/change-password-dialog.component';

import { UserApiActions } from '../../../@store/user/user.actions';
import {
  selectIsOrdersAdmin,
  selectIsOrdersManager,
  selectLoggedInUser,
} from '../../../@store/user/user.selectors';

@Component({
  selector: 'ciwc-app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  userFirstName = '';

  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly sessionManager = inject(SessionManagerService);
  private readonly dialog = inject(MatDialog);
  readonly loggedInUser = this.store.selectSignal(selectLoggedInUser);
  readonly isOrdersManager = this.store.selectSignal(selectIsOrdersManager);
  readonly isOrdersAdmin = this.store.selectSignal(selectIsOrdersAdmin);

  goToEditUser() {
    const user = this.loggedInUser();

    if (user) {
      this.router.navigate(['/users/edit', user.id]);
    }
  }

  launchChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '400px',
    });

    dialogRef.afterClosed();
  }

  logout() {
    this.store.dispatch(UserApiActions.logout());
  }
}
